import { useQuery, UseQueryOptions } from 'react-query'
import QUERIES from 'api/queries'
import { getSenderInvites, getCPAClients, getReceiverInvites, getCPAs } from './services'
import { ICPA, InviteType } from './models'
import { IUserInvite } from 'api/users/models'

export const useClients = () => useQuery(QUERIES.clients, getCPAClients)

export const useReceiverInvites = (
	type: InviteType,
	options?: Omit<UseQueryOptions<IUserInvite[], unknown, IUserInvite[], string[]>, 'queryKey' | 'queryFn'>
) => useQuery([QUERIES.receiverInvites, type], () => getReceiverInvites(type), options)

export const useCPAs = (options?: Omit<UseQueryOptions<ICPA[], unknown, ICPA[], string>, 'queryKey' | 'queryFn'>) =>
	useQuery(QUERIES.cpas, getCPAs, options)

export const useSenderInvites = (
	type: InviteType,
	options?: Omit<UseQueryOptions<IUserInvite[], unknown, IUserInvite[], string[]>, 'queryKey' | 'queryFn'>
) => useQuery([QUERIES.senderInvites, type], () => getSenderInvites(type), options)
